import { getUserRoles } from '@/utils/auth';
import { gql, useApolloClient, useQuery } from '@apollo/client';

const GET_APPLICATIONS = gql`
   query GetApplicationsByStatus(
      $status: String
      $currentStage: String
      $approvedByTechnicalStaff: Boolean
      $acceptedByTechnicalStaff: Boolean
      $acceptedByReceivingClerk: Boolean
      $recordedByReceivingClerk: Boolean
      $acceptedByPENRCENROfficer: Boolean
      $approvedByPENRCENROfficer: Boolean
      $reviewedByChief: Boolean
      $awaitingOOP: Boolean
      $OOPCreated: Boolean
      $awaitingPermitCreation: Boolean
      $PermitCreated: Boolean
      $certificateSignedByPENRCENROfficer: Boolean
      $ApprovedInventoryRequest: Boolean
   ) {
      getApplicationsByStatus(
         status: $status
         currentStage: $currentStage
         approvedByTechnicalStaff: $approvedByTechnicalStaff
         acceptedByTechnicalStaff: $acceptedByTechnicalStaff
         acceptedByReceivingClerk: $acceptedByReceivingClerk
         recordedByReceivingClerk: $recordedByReceivingClerk
         acceptedByPENRCENROfficer: $acceptedByPENRCENROfficer
         approvedByPENRCENROfficer: $approvedByPENRCENROfficer
         reviewedByChief: $reviewedByChief
         awaitingOOP: $awaitingOOP
         OOPCreated: $OOPCreated
         awaitingPermitCreation: $awaitingPermitCreation
         PermitCreated: $PermitCreated
         certificateSignedByPENRCENROfficer: $certificateSignedByPENRCENROfficer
         ApprovedInventoryRequest: $ApprovedInventoryRequest
      ) {
         ... on CSAWPermit {
            id
            applicationNumber
            applicationType
            status
            currentStage
            dateOfSubmission
         }
         ... on COVPermit {
            id
            applicationNumber
            applicationType
            status
            currentStage
            dateOfSubmission
         }
         ... on PLTCPPermit {
            id
            applicationNumber
            applicationType
            status
            currentStage
            dateOfSubmission
         }
         ... on PTPRPermit {
            id
            applicationNumber
            applicationType
            status
            currentStage
            dateOfSubmission
         }
         ... on PLTPPermit {
            id
            applicationNumber
            applicationType
            status
            currentStage
            dateOfSubmission
         }
         ... on TCEBPPermit {
            id
            applicationNumber
            applicationType
            status
            currentStage
            dateOfSubmission
         }
      }
   }
`;

export const useRecentApplications = (limit = 7) => {
   const client = useApolloClient();
   const roles = getUserRoles();

   const getQueryParamsForRole = () => {
      if (roles.includes('Technical_Staff')) {
         return {
            currentStage: 'TechnicalStaffReview'
         }
      }
      if (roles.includes('Receiving_Clerk')) {
         return {
            currentStage: 'ReceivingClerkReview'
         };
      }
      if (roles.includes('Chief_RPS') || roles.includes('Chief_TSD')) {
         return {
            awaitingOOP: true,
            currentStage: 'ForInspectionByTechnicalStaff' // no ChiefRPSReview anymore, after technical staff review it will go to this stage and the application awaits OOP
         };
      }
      if (roles.includes('PENR_CENR_Officer')) {
         return {
            currentStage: 'CENRPENRReview'
         };
      }
      if (roles.includes('Accountant')) {
         return {
            currentStage: 'AccountantReview'
         };
      }
      // Default case for other roles or no role
      return {
         status: 'In Progress'
      };
   };

   const { data, loading, error, refetch } = useQuery(GET_APPLICATIONS, {
      variables: getQueryParamsForRole(),
      fetchPolicy: 'network-only'
   });

   // console.log('Role:', roles);
   // console.log('Query params:', getQueryParamsForRole());
   // console.log('Query response:', { data, loading, error });

   return {
      recentApplications: data?.getApplicationsByStatus || [],
      loading,
      error,
      refetch
   };
};
